import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'edit_department_info';
export const useEditDepartmentInfoTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    edit_button: 'Изменить',
    toast_success: 'Отдел успешно изменён',
    toast_error: 'Не удалось изменить отдел',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    edit_button: 'Edit',
    toast_success: 'Department updated successfully',
    toast_error: 'Failed to update department',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    edit_button: 'Editar',
    toast_success: 'Departamento actualizado con éxito',
    toast_error: 'Error al actualizar el departamento',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    edit_button: 'Editar',
    toast_success: 'Departamento atualizado com sucesso',
    toast_error: 'Falha ao atualizar o departamento',
  },
}) : {}) as Record<string, unknown>;
